import { render, staticRenderFns } from "./SalaryTable.vue?vue&type=template&id=75ac0b14&scoped=true&"
import script from "./SalaryTable.vue?vue&type=script&lang=js&"
export * from "./SalaryTable.vue?vue&type=script&lang=js&"
import style0 from "./SalaryTable.vue?vue&type=style&index=0&id=75ac0b14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac0b14",
  null
  
)

export default component.exports